module.exports = __webpack_public_path__ + "static/media/icon-thebest.14ad280b.png";